export const API_ROUTES = {
    send_inquiry_email: '/form/send_inquiry_email'
}